const MEDIA_DEVICES_ERROR = 'mediaDevices API or getUserMedia method is not supported in this browser.'
class VoiceMessage {
  constructor (component) {
    this.component = component
    this.audioBlobs = []
    this.mediaRecorder = null
    this.streamBeingCaptured = null
  }

  start() {
    if (!(navigator.mediaDevices && navigator.mediaDevices.getUserMedia)) {
      this.$message.error('Dispositivos media no disponibles')

      return Promise.reject(new Error(MEDIA_DEVICES_ERROR))
    }

    const microphone = navigator.mediaDevices.getUserMedia({ audio: true })

    return microphone.then((audio) => {
      this.component.stream = audio
      this.component.streamBeingCaptured = audio
      this.component.mediaRecorder = new MediaRecorder(audio, { mimeType: 'audio/webm;codecs=opus' })
      this.component.audioBlobs = []
      this.component.mediaRecorder.addEventListener('dataavailable', (event) => {
        this.component.audioBlobs.push(event.data)
      })
      this.component.mediaRecorder.start()
    })
  }

  stop() {
    return new Promise(resolve => {
      this.component.mediaRecorder.addEventListener('stop', () => {
        const audioBlob = new Blob(this.component.audioBlobs, { type: 'audio/webm;codecs=opus' })

        resolve(audioBlob)
      })

      this.cancel()
    })
  }

  cancel() {
    this.component.mediaRecorder.stop()
    this.stopStream()
    this.resetRecordingProperties()
  }

  stopStream() {
    this.component.streamBeingCaptured.getTracks().forEach(track => track.stop())
  }

  resetRecordingProperties() {
    this.component.mediaRecorder = null
    this.component.streamBeingCaptured = null
  }
}

module.exports = { VoiceMessage }